import { useEffect, useRef, useState } from 'react'
import type { IOrder } from '../../../../Model/index.js'
import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Environment } from '../../../../environment.js'
import type { BaseModalProps } from '../../../Modal/BaseModal.js'
import { BaseModal } from '../../../Modal/BaseModal.js'
import { useDispatch } from 'react-redux'
import Actions from '../../../../Flux/index.js'
import { orderSlice } from '../../../../Flux/Slice/Order/OrderSlice.js'

export interface MultiQCModalProps {
  order: IOrder
}

export const MultiQCModal = ({ isOpen, onClose, order }: MultiQCModalProps & BaseModalProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [iframeReady, setIframeReady] = useState(false)
  const dispatch = useDispatch()

  const multiqcUrl = `${Environment.API_URL}/api/orders/${order.id}/multiqc-view`

  useEffect(() => {
    const handleLoad = () => {
      setIframeReady(true)
    }

    const iframe = iframeRef.current
    if (iframe) {
      iframe.addEventListener('load', handleLoad)
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleLoad)
      }
    }
  }, [multiqcUrl])

  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <div className="modal-box w-screen max-w-[80vw] h-full p-6 overflow-hidden">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">MultiQC Report</h3>
          <div className="flex gap-2 items-center">
            <button
              className="btn btn-sm btn-outline"
              onClick={() => dispatch(Actions[orderSlice.name].downloadOrderArtifactRequest({ orderId: order.id, artifact: 'MULTIQC' }))}
            >
              <ArrowDownTrayIcon className="w-4 h-4 mr-1" />
              Download
            </button>
            <button
              className="btn btn-circle btn-ghost"
              onClick={() => {
                onClose()
                setIframeReady(false)
              }}
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="form-control w-full h-[90%] relative">
          {!iframeReady && (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-base-100/60">
              <span className="loading loading-spinner loading-lg"></span>
            </div>
          )}

          <iframe
            data-testid={'multiqc-report-frame'}
            ref={iframeRef}
            src={isOpen ? multiqcUrl : ''}
            className={`w-full h-full border rounded transition-opacity duration-300 ${iframeReady ? 'opacity-100' : 'opacity-0'}`}
          />
        </div>
      </div>
    </BaseModal>
  )
}
